var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomizeModalSocialIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 11,
    fill: "#0C8CFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.2036L21.3924 12.1152C16.8019 8.41869 11.2094 9.73716 9.48101 14.7459C7.5391 20.3736 11.5034 27.3689 20.8947 32.6681L21.5 33.0097L22.1053 32.6681C31.4966 27.3689 35.4609 20.3736 33.519 14.7459C31.7906 9.73716 26.1981 8.41869 21.6076 12.1152L21.5 12.2036ZM20.6238 14.8084L21.5 15.6874L22.3762 14.8084C25.8618 11.3118 29.941 12.0411 31.1643 15.5862L31.2399 15.8207C32.4688 19.9112 29.4213 25.353 21.7949 29.9255L21.5 30.0994L21.2051 29.9255C13.432 25.2651 10.4156 19.7015 11.8357 15.5862C13.059 12.0411 17.1382 11.3118 20.6238 14.8084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeModalSocialIcon);
export default __webpack_public_path__ + "static/media/customize-modal-social-icon.f993982c2ea67bf224aa24d85319c3a0.svg";
export { ForwardRef as ReactComponent };